import { areDescriptionsEqual } from "../helpers/areDescriptionsEqual";
import { IndustrialProcessSchema, IndustrialProcessType } from "../types";

const INDUSTRIAL_PROCESSES_TO_MERGE: IndustrialProcessType[] = [
  IndustrialProcessSchema.enum.SURFACE_TREATMENT,
];

export const mergeProcessStepsByDescription = <
  T extends {
    description?: string | null | undefined;
    industrialProcess?: IndustrialProcessType;
  },
>(
  customSurfaceTreatments: T[],
  additionalProcessSteps: T[],
): T[] => {
  const deduplicatedCustom: T[] = [];
  customSurfaceTreatments.forEach((treatment) => {
    if (
      treatment.industrialProcess &&
      INDUSTRIAL_PROCESSES_TO_MERGE.includes(treatment.industrialProcess)
    ) {
      const exists = deduplicatedCustom.find((existing) =>
        areDescriptionsEqual(existing.description, treatment.description),
      );
      if (!exists) {
        deduplicatedCustom.push(treatment);
      }
    } else {
      deduplicatedCustom.push(treatment);
    }
  });

  const allSurfaceTreatments: T[] = [...deduplicatedCustom];

  additionalProcessSteps.forEach((additionalProcessStep) => {
    const exists = allSurfaceTreatments.find(
      (treatment) =>
        treatment.industrialProcess &&
        INDUSTRIAL_PROCESSES_TO_MERGE.includes(treatment.industrialProcess) &&
        areDescriptionsEqual(treatment.description, additionalProcessStep.description),
    );

    if (!exists) {
      allSurfaceTreatments.push(additionalProcessStep);
    }
  });

  return allSurfaceTreatments;
};
